import React from 'react';
import styled from 'styled-components';

const CalendarButtonStyled = styled.button`
  background: #28a745; /* Verde calendario */
  color: white;
  border: none;
  border-radius: 50%; /* Tondo come condivisione */
  width: 48px;
  height: 48px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 500;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);
  margin-right: 12px; /* Spazio tra i pulsanti */

  &:hover {
    background: #218838;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(40, 167, 69, 0.4);
  }

  &:active {
    transform: translateY(0);
  }

  /* ⬇️ RIMUOVI QUESTA PARTE:
  @media (min-width: 769px) {
    display: none;
  }
  */

  svg {
    width: 20px;
    height: 20px;
  }
`;


const CalendarIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"/>
  </svg>
);

const CalendarButton = ({ event }) => {
  const formatDateForCalendar = (dateString) => {
    const date = new Date(dateString);
    return date.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
  };

  const addToCalendar = () => {
    const startDate = formatDateForCalendar(event.startDate);
    const endDate = event.endDate ? 
      formatDateForCalendar(event.endDate) : 
      formatDateForCalendar(new Date(new Date(event.startDate).getTime() + 2 * 60 * 60 * 1000));

    const title = encodeURIComponent(event.title || 'Evento');
    const location = encodeURIComponent(event.location || '');
    const description = encodeURIComponent(
      (event.description ? event.description.substring(0, 200) + '...' : '') + 
      `\n\nVia Finday: https://finday.it/evento/${event.id}`
    );

    const googleUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${title}&dates=${startDate}/${endDate}&location=${location}&details=${description}`;

    window.open(googleUrl, '_blank');
  };

  return (
    <CalendarButtonStyled onClick={addToCalendar} title="Aggiungi al calendario">
      <CalendarIcon />
    </CalendarButtonStyled>
  );
};

export default CalendarButton;
